import { Switch, Route } from 'react-router-dom'

import { PilotAviationDetails } from './PilotAviationDetails'
import { PilotDetails } from './PilotDetails'

import { NotFoundPage } from 'components/common/NotFoundPage'
import { styled, apply } from 'lib/styled'

const Container = styled.div(apply('flex-1 flex flex-row p-6'))

// eslint-disable-next-line react/display-name
function PilotDetailsManager() {
  return (
    <Container>
      <Switch>
        <Route
          exact
          path={['/', '/my-pilot-info', '/my-pilot-info/personal-details']}
          component={PilotDetails}
        />
        <Route
          exact
          path={['/my-pilot-info/aviation-details']}
          component={PilotAviationDetails}
        />
        <Route component={NotFoundPage} />
      </Switch>
    </Container>
  )
}

export { PilotDetailsManager }
